import {createBrowserClient} from '@supabase/ssr'
import {Database} from "@/lib/types";

/**
 * Singleton Supabase browser client
 *
 * IMPORTANT: We cache the client to prevent:
 * 1. Multiple Realtime connections (causes subscribe/unsubscribe churn)
 * 2. Memory leaks from creating new WebSocket connections
 * 3. Race conditions in authentication state
 *
 * createBrowserClient from @supabase/ssr handles its own caching internally,
 * but we add an explicit singleton to be absolutely certain there's only
 * one client instance per browser tab.
 */
let browserClient: ReturnType<typeof createBrowserClient<Database, "public", Database["public"]>> | null = null;

export function createSPAClient() {
    if (!browserClient) {
        browserClient = createBrowserClient<Database, "public", Database["public"]>(
            process.env.NEXT_PUBLIC_SUPABASE_URL!,
            process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
        )
    }
    return browserClient
}